import { render, staticRenderFns } from "./VersionCard.vue?vue&type=template&id=512680a0&scoped=true"
import script from "./VersionCard.vue?vue&type=script&lang=js"
export * from "./VersionCard.vue?vue&type=script&lang=js"
import style0 from "./VersionCard.scss?vue&type=style&index=0&id=512680a0&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "512680a0",
  null
  
)

export default component.exports